import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import {doubleToStringMonthly} from '../../objects/CommonUse/double_functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { reformatDateToDisplay } from '../../objects/CommonUse/reformatDateToDisplay_function';
import DollarAmountCard from '../getting-started/dollar_amount_card';
import { standardNumberFormat } from '../../objects/CommonUse/double_functions';
import StatusDisplayItemOrder from '../../datasets/status_display_item_order';
import { calcMonthlyIncome } from '../../objects/CommonUse/calcMonthlyIncome';
import { rollForwardDate } from './objects/roll_forward_date_function';
import FinancialAdvisorModal from '../shared-components/financial_advisor_modal';
import calcRandomNumberWithMax from '../../objects/CommonUse/calc_random_number_with_max';
import financialAdvisorListStatus from '../shared-components/Datasets/financial_advisor_list_status';
import EventOnLitList from '../admin/datasets/event_onLit_dataset';
import calculateTotalSavings from '../moneyBuilder/savings/objects/calculate_total_savings';
import estimateUnplannedExpenses from './objects/estimate_unplanned_expenses';
import accountTypeOverview from '../moneyBuilder/text/account_type_overview';
import determineMonthlySavingsAmt from '../shared-components/objects/determineMonthlySavingsAmt';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    creditReport: state.creditReport,
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class MonthlyStatusModal extends Component {
        constructor(props) {
        super(props);
        this.gameInfo = this.props.gameInfo();
        this.state={
                expandLoans: false,
                expandExpenses: false,
                expandSavings: false,
                expandInvestments: false,
                openFinModal: false,
        }
        this.pendingJob = "";
        this.investmentsExist = false;
        this.creditScore = 0;
        this.populateAmounts();
        this.selectAdvisor();
       
    }
      
    populateAmounts() {
        this.currentGameDate = this.gameInfo.gameData.currentGameDate;
        this.avgUnplannedExpenses = 0;
        if (this.gameInfo.gameData.spendingHistory.turnCashAmtArr){
            const unplannedExpensesObj = 
                estimateUnplannedExpenses(this.gameInfo.gameData.spendingHistory.turnCashAmtArr,
                    this.gameInfo.gameData.spendingHistory.turnCreditAmtArr );
            this.avgUnplannedExpenses = unplannedExpensesObj.averageAmt;
        }
        this.reorderLineAmounts();
        this.calculateMonthlyTotal();
        this.savingsArr = [];
        this.grandTotalSavings = 0;
        if (this.gameInfo.savingsInfo.gameID){
            this.buildSavingsArr();
        }
        if (this.gameInfo.gameInvestments && this.gameInfo.gameInvestments.length > 0){
            this.addInvestmentsToSavingsArr();
        }
        this.checkIfPendingJob();
        this.reformatGameDate = reformatDateToDisplay(this.gameInfo.gameData.currentGameDate);
        if (this.props.creditScore){
            this.creditScore = this.props.creditScore;
        }else{
            const creditReport = this.props.creditReport;
            if (creditReport.creditScore){
                this.creditScore = creditReport.creditScore;
            }
        }
    }
      
    selectAdvisor(){
        this.advisorList = financialAdvisorListStatus;
        const advisorNbr = calcRandomNumberWithMax(8,true,1);
        const advisorName = this.advisorList[advisorNbr].name;
        const introText = this.advisorList[advisorNbr].introText;
        const advisorURL = './assets/MonthlyStatus/' + this.advisorList[advisorNbr].imageURL;
        this.advisorObj = {advisorNbr: advisorNbr, advisorName: advisorName, 
            introText: introText, advisorURL: advisorURL};
    }

    reorderLineAmounts(){
        this.statusDisplayItemOrder = StatusDisplayItemOrder
        var tableItem = "";
        this.assetMaxNbr = 0;
        this.expenseMaxNbr = 0;
        this.loanMaxNbr = 0;

        this.assetTable = [];
        for (let i=0; i<this.gameInfo.gameData.assetTable.length; i++){
             tableItem = this.gameInfo.gameData.assetTable[i].assetItem;
             this.assignOrderNbr(tableItem,  i);
             let assetObj = {...this.gameInfo.gameData.assetTable[i], order: this.lineOrder};
             this.assetTable.push(assetObj);
        }
        this.assetTable.sort((a, b) => (a.order > b.order) ? 1 : -1);
        this.expenseTable = [];
        for (let i=0; i<this.gameInfo.gameData.expenseTable.length; i++){
            tableItem = this.gameInfo.gameData.expenseTable[i].expItem;
            this.assignOrderNbr(tableItem, i);
            let expenseTable = JSON.parse(JSON.stringify(this.gameInfo.gameData.expenseTable[i]));
            this.insertExpenseEndDate(expenseTable);
            let expenseObj = {...expenseTable, order: this.lineOrder};
            this.expenseTable.push(expenseObj);
        }
        this.assignOrderNbr("Discretionary Expenses", 0);
        if (+this.avgUnplannedExpenses > 0){
            const unplannedExpItem = {expItem: "Discretionary Expenses", 
                expDesc: "Estimated discretionary (unplanned) expenses", expAmount: this.avgUnplannedExpenses,
                expStartDate: this.gameInfo.gameData.currentGameDate, expNbrMonths: -1, order: this.lineOrder};
            this.expenseTable.push(unplannedExpItem);
        }
        this.expenseTable.sort((a, b) => (a.order > b.order) ? 1 : -1);
        this.expenseTable = this.checkIfCombine(this.expenseTable);
        this.loanTable = [];
        for (let i=0; i<this.gameInfo.gameData.loanTable.length; i++){
            tableItem = this.gameInfo.gameData.loanTable[i].loanType;
            let loanTable = JSON.parse(JSON.stringify(this.gameInfo.gameData.loanTable[i]))
            if (loanTable.loanNbrMonths !== 0){
                this.assignOrderNbr(tableItem, i);
                this.insertLoanEndDate(loanTable);
                let loanObj = {...loanTable, order: this.lineOrder, loanDesc2: this.loanDesc2};
                if (this.loanDesc3 !== ""){
                    loanObj = {...loanObj, loanDesc3: this.loanDesc3, loanDesc4: this.loanDesc4}
                }
                this.loanTable.push(loanObj);
            }
        }
        this.loanTable.sort((a, b) => (a.order > b.order) ? 1 : -1);
    }

    insertExpenseEndDate(expenseTable){
        if (+expenseTable.expNbrMonths === -1 ||
            +expenseTable.expNbrMonths === 0){
               // do not add end date
        }else{
            let expenseNbrMonths = +expenseTable.expNbrMonths;
            let expenseEndDate = rollForwardDate(this.gameInfo.gameData.currentGameDate, expenseNbrMonths);
            expenseTable.expDesc = expenseTable.expDesc + "- Expense Will End " + reformatDateToDisplay(expenseEndDate);
        }
    }

    insertLoanEndDate(loanTable){
        if (loanTable.loanDesc.includes ("Loan Fully Paid")){
               // do not add end date a second time
        }else{
            let loanNbrMonths = +loanTable.loanNbrMonths;
            const totalLoanMonths = (+loanTable.loanTerm * 12).toFixed(0);
            const loanMonthsPaid = +totalLoanMonths - +loanTable.loanNbrMonths;
            const loanAmtPaid = (+loanMonthsPaid * +loanTable.loanAmt).toFixed(2);
            let loanEndDate = rollForwardDate(this.gameInfo.gameData.currentGameDate, loanNbrMonths);
            this.loanDesc2 = "Fully Paid by " + reformatDateToDisplay(loanEndDate)
            this.loanDesc3 = "";
            this.loanDesc4 = "";
            if (loanMonthsPaid !== 0){
                this.loanDesc3 = "Initial Amount: " + doubleToStringMonthly(loanTable.loanTotAmt);
                this.loanDesc4 = "Amt Paid so Far: " + doubleToStringMonthly(loanAmtPaid);
            }
        }
    }

    assignOrderNbr(amountType, indx){
        const orderObj = this.statusDisplayItemOrder.find(elem => elem.item === amountType);
        if (orderObj ){
            this.lineOrder = orderObj.order + indx;
        }else{
            this.lineOrder = 9999 - indx;
        }
    }

    checkIfCombine(inputTable){
        let outputTable = [];
        let combined = false;
        let saveInitialIndx = 0;
        let writeSw = false;
        for (let i=0; i<inputTable.length; i++){
            let prev = outputTable.length - 1;
            if (i > 0 && inputTable[i].expItem === outputTable[prev].expItem &&
                outputTable[prev].expNbrMonths !== 0){
                let onLitObj = EventOnLitList.find(elem => elem.value === inputTable[i].expItem);
                if (onLitObj  && onLitObj.creditCard === false){
                    if (saveInitialIndx === 0){
                        saveInitialIndx = prev;
                        combined = true;
                    }
                    outputTable[saveInitialIndx].expAmount = +outputTable[saveInitialIndx].expAmount + 
                        +inputTable[i].expAmount;
                }else{
                    writeSw = true;
                }
            }else{
                writeSw = true;
            }
            if (writeSw === true){
                if (combined === true){
                    combined = false;
                    saveInitialIndx = 0;
                }        
                outputTable.push(inputTable[i]);
                writeSw = false;
            }
        }
        return outputTable;
    }

    calculateMonthlyTotal() {
        this.monthlyIncomeObj = calcMonthlyIncome(this.gameInfo.gameData.assetTable,
            this.expenseTable, this.gameInfo.gameData.loanTable);
        this.monthlyTotalAmt = this.monthlyIncomeObj.income
        
    }

    checkIfPendingJob(){
        this.pendingJob = false;
        if (this.gameInfo.gameData.pendingJob && 
            Object.keys(this.gameInfo.gameData.pendingJob).length !== 0){
            this.pendingJob = true;
            let pendingJob = this.gameInfo.gameData.pendingJob;
            let reformatDate = reformatDateToDisplay(pendingJob.jobStartDate);
            let pendingJobObj = {textLine: pendingJob.jobInfo.careerName, startDate: reformatDate};
            this.pendingJob = pendingJobObj;
        }
    }

    buildSavingsArr(){
        const monthlySavingsAmt = determineMonthlySavingsAmt(this.gameInfo.savingsInfo);
        let savingsObj = {item: "Monthly Savings Amount", 
            desc: "Total Amount saved each month across all accounts",
            amount: monthlySavingsAmt};
        this.savingsArr.push(savingsObj);
        this.grandTotalSavings = 0;
        const savingsInfoArr = this.gameInfo.savingsInfo.savingsArr;
        let savingsTotalObj = calculateTotalSavings(savingsInfoArr, this.gameInfo.gameData.gameNbrMonths,
             "bank" );
        let savingsClassObj = accountTypeOverview.find(elem => elem.accountType === "bank");
        let itemName = savingsClassObj.label;
        let itemDesc = savingsClassObj.longDesc;
        let totalSavings = savingsTotalObj.totalSavings;
        this.grandTotalSavings += +totalSavings;
        savingsObj = {item: itemName, desc: itemDesc, amount: totalSavings};
        this.savingsArr.push(savingsObj);
        savingsTotalObj = calculateTotalSavings(savingsInfoArr, this.gameInfo.gameData.gameNbrMonths, 
            "retirement" );
        if (savingsTotalObj.totalBeforeMatchAmt > 0){
            savingsClassObj = accountTypeOverview.find(elem => elem.accountType === "retirement");
            itemName = savingsClassObj.label;
            itemDesc = savingsClassObj.longDesc;
            totalSavings = savingsTotalObj.totalBeforeMatchAmt;
            this.grandTotalSavings += +totalSavings;
            savingsObj = {item: itemName, desc: itemDesc, amount: totalSavings};
            this.savingsArr.push(savingsObj);
            itemName = "Company Match Amount";
            itemDesc = "Total amount of company match for all retirement saving accounts";
            totalSavings = savingsTotalObj.totalMatchAmt;
            savingsObj = {item: itemName, desc: itemDesc, amount: totalSavings};
            this.savingsArr.push(savingsObj);
            this.grandTotalSavings += +savingsTotalObj.totalMatchAmt;
        }
    }
    
    addInvestmentsToSavingsArr(){
        let investmentObj = {};
        const summaryInvestObj = this.gameInfo.summaryInvestment.find(elem => elem.investType === "all");
        if (summaryInvestObj){
            const itemDesc = "Current Value of all Investments";
            const currentAmount = summaryInvestObj.currentValue;
            this.grandTotalSavings += +currentAmount;
            investmentObj = {item: "Investments",  desc: itemDesc, amount: currentAmount };
            this.savingsArr.push(investmentObj);
        }
    }
  
    toggleIncomeType(incomeType){
        switch (incomeType) {
            case "assets":
                this.setState({expandAssets: !this.state.expandAssets});
                break;
            case "expenses":
                this.setState({expandExpenses: !this.state.expandExpenses});
                break;
            case "loans":
                this.setState({expandLoans: !this.state.expandLoans});
                break;
            case "savings":
                this.setState({expandSavings: !this.state.expandSavings});
                break;
            case "investments":
                this.setState({expandInvestments: !this.state.expandInvestments});
                break;
            default:
                break;
        }
    }  
    
    openFinancialAdvisorModal(){
        this.setState({openFinModal: true});
    }

    closeFinancialAdvisorModal(){
        this.setState({openFinModal: false});
    }

    goToNewProcess(newProcessName){
        this.props.setInfoRedux("monthly-status", "prevProcess");
        this.props.onNavigate(newProcessName);
    }
    
    render() {
        this.savingsAccount = false;
        if (this.gameInfo.savingsInfo) 
              if ((this.gameInfo.savingsInfo.monthlySavingsAmt &&
                  this.gameInfo.savingsInfo.monthlySavingsAmt > 0)  || 
                  (this.gameInfo.savingsInfo.totalSavingsAmt &&
                  this.gameInfo.savingsInfo.totalSavingsAmt > 0)){
                        this.savingsAccount = true;
        }  
        if (this.state.expandAssets ===true){
            this.assetList = this.assetTable.map((assetAmt,key) =>
                <DollarAmountCard  key={key}  amtType="asset" amountInfo={assetAmt} className = ""
                        gameDate={this.gameInfo.gameData.currentGameDate}
                />
            );
        }
        if (this.state.expandExpenses ===true){
            this.expenseList = this.expenseTable.map((expenseAmt,key) =>
                <DollarAmountCard  key={key}  amtType="expense" amountInfo={expenseAmt} className = "text-danger"
                    gameDate={this.gameInfo.gameData.currentGameDate}
                />
            );
        }

       if (this.state.expandLoans ===true){ 
            this.loanList = this.loanTable.map((loanAmt,key) =>
                <DollarAmountCard  key={key}  amtType="loan" amountInfo={loanAmt} className = "text-danger"
                    gameDate={this.gameInfo.gameData.currentGameDate}
                />
            );
       }
       if (this.state.expandSavings === true && this.savingsAccount){
            this.savingsList = this.savingsArr.map((savingsAmt, index) =>
                <DollarAmountCard  key={index} amtType="general" amountInfo={savingsAmt} 
                    className={this.savingsArr[index].className}
                    gameDate={this.gameInfo.gameData.currentGameDate}
                />
                );
       }
       if (this.state.expandInvestments === true && this.investmentsExist === true){
            this.investmentsList = this.investmentsArr.map((investmentAmt, index) =>
                <DollarAmountCard  key={index} amtType="general" amountInfo={investmentAmt} 
                    gameDate={this.gameInfo.gameData.currentGameDate}
                />
                );
       }
       let cashClass = "col-sm-2 p-0 text-right";
       if (this.gameInfo.gameData.currentCash < 0){
            cashClass = "col-sm-2 p-0 text-right text-danger"
       };
   
     return <>
      
        <Modal show={this.props.modalOpen}  onHide={() => this.props.onClose()} size="lg" scrollable="true"
            dialogClassName="gameview-modal-size" className="modal-border" animation={false}>
            <Modal.Header className="backgroundTopBottom" closeButton >
            <Modal.Title className="ml-4">Monthly Budget - Current Game Date &nbsp;
                    {reformatDateToDisplay(this.gameInfo.gameData.currentGameDate)}
                    <div >
                        Player:&nbsp;&nbsp; {this.gameInfo.gameData.user}
                    </div>
                    </Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-border">
            <span>                
                <table className="table table-hover">
                    <thead>
                        <tr className="thead-light">
                            <th className="p-0 col-sm-4" scope="col">Item</th>
                            <th className="p-0 col-sm-5" scope="col">Description</th>
                            <th className="p-0 col-sm-3 text-right" scope="col">Amount</th>
                        </tr>
                    </thead>
                </table>
                {this.state.expandAssets ?
                    <table className="table table-hover">
                        <tbody>
                        <tr className="thead-light" onClick={() => this.toggleIncomeType("assets")}>
                                <th className="p-0 col-sm-4" scope="col">Total Income&nbsp;&nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCaretDown} className="career_card_caret" /> </th>
                                <th className="p-0 col-sm-5"></th>
                                <th className="p-0 col-sm-3"></th>
                            </tr>
                            {this.assetList}
                            <tr className="thead-light" onClick={() => this.toggleIncomeType("assets")}>
                                <th className="p-0 col-sm-4 " scope="col">Total Income (Salary & Other)</th>
                                <th className="p-0 col-sm-5 " scope="col"></th>
                                <th className="p-0 col-sm-3 text-right" scope="col">
                                                {doubleToStringMonthly(this.monthlyIncomeObj.assets)}</th>
                            </tr>
                        </tbody>
                    </table>
                :
                    <table className="table table-hover">
                        <tbody>
                            <tr className="thead-light" onClick={() => this.toggleIncomeType("assets")}>
                                <th className="p-0 col-sm-4" scope="col">Total Income&nbsp;&nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCaretRight} className="career_card_caret" /> 
                                    </th>
                                <th className="p-0 col-sm-5" scope="col"> </th>
                                
                                <th className="p-0 col-sm-3 text-right" scope="col">
                                        {doubleToStringMonthly(this.monthlyIncomeObj.assets)}</th>
                            </tr>
                        </tbody>
                    </table>
                }
              
             {this.state.expandExpenses ?
                <table className="table table-hover">
                    <tbody>
                    <tr className="thead-light" onClick={() => this.toggleIncomeType("expenses")}>
                            <th className="p-0 col-sm-4 text-danger" scope="col">Total Expenses&nbsp;&nbsp;&nbsp;
                            <FontAwesomeIcon icon={faCaretDown} className="career_card_caret" /> </th>
                            <th className="p-0 col-sm-5"></th>
                             <th className="p-0 col-sm-3"></th>
                        </tr>
                         {this.expenseList}
                        <tr className="thead-light" onClick={() => this.toggleIncomeType("expenses")}>
                            <th className="p-0 col-sm-4 text-danger" scope="col">Total Expenses</th>
                            <th className="p-0 col-sm-5 text-danger" scope="col"></th>
                             <th className="p-0 col-sm-3 text-danger text-right" scope="col">
                                            {doubleToStringMonthly(this.monthlyIncomeObj.expenses)}</th>
                        </tr>
                    </tbody>
                </table>
            :
                <table className="table table-hover">
                    <tbody>
                        <tr className="thead-light" onClick={() => this.toggleIncomeType("expenses")}>
                            <th className="p-0 col-sm-4 text-danger" scope="col">Total Expenses&nbsp;&nbsp;&nbsp;
                            <FontAwesomeIcon icon={faCaretRight} className="career_card_caret" /> 
                               </th>
                            <th className="p-0 col-sm-5 text-danger" scope="col"> </th>
                              
                            <th className="p-0 col-sm-3 text-danger text-right" scope="col">
                                    {doubleToStringMonthly(this.monthlyIncomeObj.expenses)}</th>
                        </tr>
                    </tbody>
                </table>
            }
            {this.state.expandLoans ?
                <table className="table table-hover">
                    <tbody>
                        <tr className="thead-light" onClick={() => this.toggleIncomeType("loans")}>
                            <th className="p-0 col-sm-4 text-danger" scope="col">Total Loans &nbsp;&nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCaretDown} className="career_card_caret" /> </th>
                            <th className="p-0 col-sm-5 text-danger" scope="col"></th>
                            <th className="p-0 col-sm-3 text-danger text-right" scope="col"></th>
                        </tr>
                        {this.loanList}
                        <tr className="thead-light" onClick={() => this.toggleIncomeType("loans")}>
                            <th className="p-0 col-sm-4 text-danger" scope="col">Total Loans</th>
                            <th className="p-0 col-sm-5 text-danger" scope="col"></th>
                            <th className="p-0 col-sm-3 text-danger text-right" scope="col">
                                    {doubleToStringMonthly(this.monthlyIncomeObj.loans)}</th>
                        </tr>
                    </tbody>
                </table>
            :
                <table className="table table-hover">
                    <tbody>
                        <tr className="thead-light" onClick={() => this.toggleIncomeType("loans")}>
                            <th className="p-0 col-sm-4 text-danger" scope="col">Total Loans &nbsp;&nbsp;&nbsp;
                            <FontAwesomeIcon icon={faCaretRight} className="career_card_caret" /> </th>
                            <th className="p-0 col-sm-5 text-danger" scope="col"></th>
                            <th className="p-0 col-sm-3 text-danger text-right" scope="col">
                                    {doubleToStringMonthly(this.monthlyIncomeObj.loans)}</th>
                        </tr>
                    </tbody>
                </table>
            }
                    
            {this.monthlyTotalAmt < 0 ?    
                <table className="table table-hover">
                    <tbody>      
                        <tr className="text-danger">
                            <th className="p-0" scope="row" colSpan="2">Monthly Total</th>
                            <th className="col-sm-6 p-0">Expenses are greater than income</th>
                            <th className="p-0 text-right">- {doubleToStringMonthly(this.monthlyTotalAmt * -1)}</th>
                        </tr>
                    </tbody>
                </table>
            :
                <table className="table table-hover">
                    <tbody>
                        <tr>
                            <th className="col-sm-4 p-0" scope="row" colSpan="2">Monthly Total</th>
                            <th className="col-sm-6 p-0">Amount of income each month</th>
                            <th className="col-sm-2 p-0 text-right">{doubleToStringMonthly(this.monthlyTotalAmt)}</th>
                        </tr>
                    </tbody>
                </table>
            }
            
            <table className="table table-hover">
                <tbody>
                    {this.props.fromProcess === "status" ?
                        <tr>
                            <th className="col-sm-4 p-0" scope="row" >Current Credit Score</th>
                                <td className="col-sm-6 p-0 text-center text-pointer">
                                    <Button variant="secondary" size="sm"
                                        onClick={() => this.props.openCreditReportModal()}>
                                        Display Your Credit Report
                                    </Button>
                                </td>
                            <td className="col-sm-2 p-0 text-right" colSpan="2">
                                {standardNumberFormat(this.creditScore)}</td>
                        </tr>
                    :
                            null
                    }
                    <tr>
                        <th className="col-sm-4 p-0" scope="row" colSpan="2">Current Cash Total</th>
                        <td className="col-sm-6 p-0"></td>
                        <td className={cashClass}>
                            {doubleToStringMonthly(this.gameInfo.gameData.currentCash)}</td>
                    </tr>
                    <tr>
                        <th className="col-sm-4 p-0" scope="row" colSpan="2">Current Mood Points</th>
                        <td className="col-sm-6 p-0"></td>
                        <td className="col-sm-2 p-0 text-right">
                            {standardNumberFormat(this.gameInfo.gameData.currentMoodPoints)}</td>
                    </tr>
                </tbody>
            </table>
            
            {this.savingsAccount ?
                <span>
                <h5 className="text-center">--------Savings and Investments--------</h5>
                {this.state.expandSavings ?
                    <table className="table table-hover p-0">
                            <tbody>
                                <tr className="thead-light" onClick={() => this.toggleIncomeType("savings")}>
                                    <th className="col-sm-4 p-0" scope="col">Summary By Type
                                    <FontAwesomeIcon icon={faCaretDown} className="career_card_caret" /> </th>
                                    {this.props.fromProcess === "status" ?
                                        <td className="col-sm-5 p-0 text-center text-pointer">
                                                <Button variant="secondary" size="sm"
                                                    onClick={() => this.goToNewProcess("conductor-dashboard")}>
                                                    Go To Savings and Investments 
                                                </Button>
                                        </td>
                                    :
                                        <td></td>
                                    }
                                    <th className="col-sm-3 text-right p-0"></th>
                                </tr>
                             
                                {this.savingsList}
                                <tr className="thead-light" onClick={() => this.toggleIncomeType("savings")}>
                                    <th className="col-sm-4 p-0" scope="col">Total Savings & Investments&nbsp;&nbsp;</th>
                                    <th className="col-sm-5 p-0"> </th>
                                    <th className="col-sm-3 text-right p-0">
                                            {doubleToStringMonthly(+this.grandTotalSavings)}</th>
                                </tr>
                            </tbody>
                        </table> 
                    :
                        <table className="table table-hover p-0">
                            <tbody>
                                <tr className="thead-light" onClick={() => this.toggleIncomeType("savings")}>
                                    <th className="col-sm-4 p-0" scope="col">
                                        Total Savings & Investments&nbsp;&nbsp;&nbsp;
                                    <FontAwesomeIcon icon={faCaretRight} className="career_card_caret" /> </th>
                                   <td className="col-sm-5 p-0 text-center text-pointer">
                                            <Button variant="secondary" size="sm"
                                                 onClick={() => this.goToNewProcess("conductor-dashboard")}>
                                            
                                                Go To Savings and Investments 
                                            </Button>
                                    </td>
                                    <th className="col-sm-3 p-0 text-right">
                                        {doubleToStringMonthly(+this.grandTotalSavings)}</th>
                                </tr>
                            </tbody>
                        </table>
                    }
                    </span>
                :
                        null 
                }
                                     
                <table className="table table-hover">
                    <tbody>
                        {this.pendingJob ?
                            <tr className="row-100">
                                <th className="col-sm-4 p-0">Pending Job</th>
                                <th className="col-sm-6 p-0 text-left">{this.pendingJob.textLine}</th>
                                <td className="col-sm-2 p-0 text-right">Start Dt: {this.pendingJob.startDate}</td>
                            </tr>
                        :
                            null
                        }
                    
                    </tbody>
               </table>
            </span>
            
            {this.state.openFinModal  ?
                <FinancialAdvisorModal 
                    modalOpen = {this.state.openFinModal}
                    gameInfo = {() => this.props.gameInfo()}
                    adviceType = {"status"}
                    advisorObj = {this.advisorObj}
                    expenseTable = {this.expenseTable}
                    monthlyTotalAmt ={this.monthlyTotalAmt}
                    onClose = {() => this.closeFinancialAdvisorModal()}
                />
            :
                null
            }

        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom">
            <div>
                <img className="monthly-status-chat-icon" onClick={() => this.openFinancialAdvisorModal()} 
                    src={'./assets/MonthlyStatus/chatIcon.png'}  alt="chatIcon"/>
            </div>
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                      Close
            </Button>
        </Modal.Footer>
        </Modal>
       
        </>
    }

   
    backToOptionSelection() {
        this.props.onNavigate("status-display");
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyStatusModal);